import React, { Component, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Request from 'components/Request';
import InfractionSummary from './InfractionSummary';
import Infraction from 'models/Infraction';
import LoaderFullPage from '../elements/LoaderFullPage';
import * as modActions from '../redux/actions/mod';
import InfiniteScroll from 'react-infinite-scroller';
import EmptyMatchmakingTabComponent from "../elements/EmptyMatchmakingTabComponent";

function InfractionList(props) {
	const { playerId, reportId } = props;
	const [infractions, updateInfractionList] = useState([]);
	const [loading, updateLoading] = useState(false);
	const [banDiscussionUrl, updateBanDiscussionUrl] = useState(null);

	const [hasMore, updateHasMore] = useState(true);
	const [finishedLoadingMore, updateFinishedLoadingMore] = useState(false);

	const previousLoadMore = useRef(Promise.resolve());


	const infractionRequestBasic = { report_id: reportId, player_id: playerId };

	const addInfractionsToInfractionList = useCallback((response) => {
		if(response.infractions.length === 0) {
			return false;
		}
		const updatedList = [...infractions, ...Infraction.updateMany(response.infractions)];
		updateInfractionList(updatedList);
		if(response.ban_discussion_url) {
			updateBanDiscussionUrl(response.ban_discussion_url);
		}
		return true;
	}, [playerId, reportId, infractions]);

	const loadMore = useCallback((page) => {
		if(!playerId && !reportId) {
			return;
		}
		updateHasMore(false);
		updateLoading(true);
		const previousHasMore = hasMore;
		console.log('the page', page);
		previousLoadMore.current
			.then(() => {
				return previousLoadMore.current = Request.apiv1Get('infraction/visible_infractions', {
					...infractionRequestBasic,
					page: page
				});
			})
			.then((response) => {
				return addInfractionsToInfractionList(response);
			})
			.then((hasMore) => {
				updateHasMore(hasMore);
				if(!hasMore) {
					updateFinishedLoadingMore(true);
				}
			})
			.catch((error) => {
				updateHasMore(previousHasMore);
				Request.generalJsonError(error);
			})
			.finally(() => {
				updateLoading(false);
			});
	}, [playerId, reportId, addInfractionsToInfractionList]);

	const infiniteScrollProps = useMemo(() => {
		const infiniteScrollProps = {};
		infiniteScrollProps.pageStart = 0;
		infiniteScrollProps.loadMore = loadMore;
		infiniteScrollProps.hasMore = hasMore;
		infiniteScrollProps.initialLoad = true;
		// infiniteScrollProps.getScrollParent = getScrollParent;
		infiniteScrollProps.useWindow = true;
		return infiniteScrollProps;
	}, [loading, hasMore]);

	return (
		<div>
			{!!banDiscussionUrl &&
			<div>
				<a href={banDiscussionUrl}>View Ban Discussion</a>
			</div>
			}
			<InfiniteScroll
				{...infiniteScrollProps}
			>
				{infractions.map((infraction) => (
					<InfractionSummary
						key={infraction.id}
						infraction={infraction}
						isOnePlayerOnly={!!playerId}
					/>
				))}
			</InfiniteScroll>
			{loading &&
			<LoaderFullPage
				text={`Fetching Infractions`}
			/>
			}
			{(!hasMore && finishedLoadingMore) && <EmptyMatchmakingTabComponent>
				{infractions.length === 0 && <span>None to show! :D</span>}
				{infractions.length !== 0 &&
				<div>We made it to the end! <div>(These are typically just warnings to let you know that a rule has been
					broken)</div>
				</div>}
			</EmptyMatchmakingTabComponent>
			}
		</div>
	);
}

function mapStateToProps(state) {
	return {
		...state.mod,
		...state.matchmaking, // For Ladder Mod Data?
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...modActions
	}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InfractionList);